import styled from 'styled-components';

export const StyledPaymentPromoCodeContainer = styled.div`
  width: 100%;
`;

type StyledPaymentPromoCodeFormProps = {
  error: boolean;
};
export const StyledPaymentPromoCodeForm = styled.form<StyledPaymentPromoCodeFormProps>`
  display: grid;
  grid-template-columns: 1.72fr 0.93fr;
  gap: 10px;
  margin-bottom: ${({ error }) => (error ? '5px' : '0px')};
`;

export const StyledPromoCodeInput = styled.input`
  width: 100%;

  padding: 10px 6px 10px 12px;
  background: #ffffff;
  border-radius: 4px;

  border: 1px solid #c1c1c1;
  box-shadow: none;

  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #1d201f;

  &::placeholder {
    color: #c1c1c1;
  }

  &:focus {
    outline: none;
  }

  &.success {
    background: linear-gradient(0deg, rgba(71, 136, 98, 0.1), rgba(71, 136, 98, 0.1)), #ffffff;
    border: 1px solid #478862;
  }

  &.failure {
    border: 1px solid #c13e18;
  }
`;

export const StyledPromoCodeButton = styled.button`
  padding: 9px;

  border-radius: 4px;
  width: 100%;
  height: 36px;
  background-color: #177590;
  display: flex;
  align-items: center;
  justify-content: center;

  &.disabled {
    background: #eeeeee;
    span {
      color: #c1c1c1 !important;
    }
  }

  span {
    color: #ffffff;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
  }

  ion-spinner {
    height: 20px;
    width: 20px;
  }
`;

export const CTAPromoCode = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  cursor: pointer;
  margin-bottom: 20px;

  color: #177590;
`;

export const StyledFailureOrSuccessMessage = styled.p`
  display: flex;
  align-items: center;

  font-style: normal;
  font-size: 12px;
  line-height: 14px;

  svg {
    margin-right: 4px;
  }

  span {
    font-style: normal;
    font-size: 12px;
    line-height: 14px;
  }

  &.failure {
    color: #c13e18;
  }

  &.success {
    color: #478862;
  }
`;

export const SuccessPromoInput = styled.div`
  background: #ffffff;
  border: 1px solid #c1c1c1;
  width: 210px;
  border-radius: 4px;
  padding: 7px 12px;
  color: #1d201f;
  display: flex;
  align-items: center;
  column-gap: 6px;
  font-size: 18px;
  height: 34px;

  & span {
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;
  }
`;

export const SuccessPromoDiscount = styled.h4`
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: #26b183;
`;

export const SuccessPromoWrapper = styled.div`
  margin-bottom: 15px !important;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;
